import { Dispatch } from 'redux';
import {
  jwtTokenSelector,
  mmiSelector,
  PaymentInfoDataSelector
} from 'store/billing/Payment/selectors';
import { PaymentForm } from 'store/billing/Payment/types';
import { consumerIdSelector } from 'store/profile/selectors';

export const WEBPAY_AUTHENTICATE = 'WEBPAY.AUTHENTICATE';
export const WEBPAY_AUTHENTICATE_SUCCESS = 'WEBPAY.AUTHENTICATE_SUCCESS';
export const WEBPAY_AUTHENTICATE_FAIL = 'WEBPAY.AUTHENTICATE_FAIL';

export const WEBPAY_PAYMENTINFO = 'WEBPAY.PAYMENTINFO';
export const WEBPAY_PAYMENTINFO_SUCCESS = 'WEBPAY.PAYMENTINFO_SUCCESS';
export const WEBPAY_PAYMENTINFO_FAIL = 'WEBPAY.PAYMENTINFO_FAIL';
export const WEBPAY_PAYMENTINFO_RESET = 'WEBPAY.PAYMENTINFO_RESET';

export const WEBPAY_APPLYPAYMENT = 'WEBPAY.APPLYPAYMENT';
export const WEBPAY_APPLYPAYMENT_SUCCESS = 'WEBPAY.APPLYPAYMENT_SUCCESS';
export const WEBPAY_APPLYPAYMENT_FAIL = 'WEBPAY.APPLYPAYMENT_FAIL';

export const WEBPAY_ACCOUNT_SAVINGS = '37';
export const WEBPAY_ACCOUNT_CHECKING = '27';

export const authenticatePin = (webpayAuth: { fac: string; account: string; pin: string }) => ({
  type: WEBPAY_AUTHENTICATE,
  payload: {
    client: 'webpay',
    request: {
      method: 'post',
      url: '/public/authenticatePin',
      headers: {
        Accept: 'application/json',
        Connection: 'keep-alive',
        'Content-Type': 'application/json'
      },
      data: {
        fac: webpayAuth.fac,
        account: webpayAuth.account,
        pin: webpayAuth.pin
      }
    }
  }
});

export const paymentInfo = () => async (dispatch: Dispatch, getState: Function) => {
  const token = await jwtTokenSelector(getState());
  let mmi = await mmiSelector(getState());
  if (mmi === null || mmi === undefined) {
    mmi = await consumerIdSelector(getState());
  }

  return dispatch({
    type: WEBPAY_PAYMENTINFO,
    payload: {
      client: 'webpay',
      request: {
        method: 'post',
        url: '/secure2/getPaymentInfo',
        headers: {
          Accept: 'application/json',
          Connection: 'keep-alive',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        data: {
          guarantor: {
            mmi
          }
        }
      }
    }
  });
};

export const resetPaymentInfo = () => ({
  type: WEBPAY_PAYMENTINFO_RESET
});

export const applyPayment = (form: PaymentForm) => async (
  dispatch: Dispatch,
  getState: Function
) => {
  const token = await jwtTokenSelector(getState());
  let mmi = await mmiSelector(getState());
  if (mmi === null || mmi === undefined) {
    mmi = await consumerIdSelector(getState());
  }

  const data = await PaymentInfoDataSelector(getState());

  await form.encounters.forEach((item, index) => {
    data.accountList[index].paymentAmount = item.paymentAmount;
  });

  let totalPlanPaymentAmount = 0;
  await form.paymentPlans.forEach((item, index) => {
    data.paymentPlanList[index].paymentAmount = item.paymentAmount;
    totalPlanPaymentAmount = Number(totalPlanPaymentAmount) + Number(item.paymentAmount);
  });

  const collectorApp = 'DFDMOBILE';

  let paymentOption = 'ACCOUNT';
  switch (form.paymentOption) {
    case '1':
      paymentOption = 'ACCOUNT';
      break;
    case '2':
      paymentOption = 'FULL';
      break;
    case '3':
      paymentOption = 'PLAN';
      break;
    case '4':
      paymentOption = 'OTHER';
      break;
    default:
      paymentOption = 'ACCOUNT';
      break;
  }

  let methodOption = '';
  switch (form.paymentMethod) {
    case '1':
      methodOption = 'CR';
      break;
    case '2':
      methodOption = 'CK';
      break;
    default:
      methodOption = 'CR';
      break;
  }

  data.paymentDetail = {
    collectorApp,
    paymentOption,
    totalPaymentAmount: form.paymentAmount,
    totalPlanPaymentAmount,
    methodOption,
    saveEmail: true,
    firstName: form.firstName.trim(),
    lastName: form.lastName.trim(),
    address: form.address,
    state: form.state,
    city: form.city,
    zip: form.zip,
    email: form.emailAddress,
    email2: form.emailAddress2
  };
  if (methodOption === 'CK') {
    data.paymentDetail.bankAccountType =
      form.accountType === '1' ? WEBPAY_ACCOUNT_SAVINGS : WEBPAY_ACCOUNT_CHECKING;
    data.paymentDetail.routingNumber = form.routingNumber;
    data.paymentDetail.accountNumber = form.accountNumber;
  } else if (methodOption === 'CR') {
    data.paymentDetail.cardNumber = form.cardNumber.replace(/\s/g, '');
    data.paymentDetail.expMonth = form.cardExpiration.substring(0, 2);
    data.paymentDetail.expYear = form.cardExpiration.substring(3, 5);
    data.paymentDetail.cvv2Code = form.cardCvv;
  }

  return dispatch({
    type: WEBPAY_APPLYPAYMENT,
    payload: {
      client: 'webpay',
      request: {
        method: 'post',
        url: '/secure2/applyPayment',
        headers: {
          Accept: 'application/json',
          Connection: 'keep-alive',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        data
      }
    }
  });
};
